// removed by extract-text-webpack-plugin
module.exports = {"mydiv":"mydiv","ant-card-body":"ant-card-body","ant-card-head":"ant-card-head","ant-card-head-title":"ant-card-head-title","mydivheader":"mydivheader","static":"static"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DraggableEntity/Draggable.scss
// module id = 4908
// module chunks = 1